import { render, staticRenderFns } from "./sidemenu_instagram.vue?vue&type=template&id=d214577c&scoped=true&"
import script from "./sidemenu_instagram.vue?vue&type=script&lang=js&"
export * from "./sidemenu_instagram.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu_instagram.vue?vue&type=style&index=0&id=d214577c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d214577c",
  null
  
)

export default component.exports